export function blockPosts(){
    const Flickity = require('flickity');
    const containers = document.querySelectorAll('.posts_container');

    containers.forEach((container) => {
        let flkty = new Flickity(container, {
            draggable: true,
            cellAlign: "center",
            prevNextButtons: false,
            pageDots: false,
            watchCSS: true
        })
    })

}